module.exports = __webpack_public_path__ + "img/tran_take_sc_ewm.af03e74c.png";